import type { CSSProperties } from 'react'
import type { ResponsiveAsset } from '../types'

type EditorialMediaProps = ResponsiveAsset & {
  label: string
  index?: number
  className?: string
}

export function EditorialMedia({
  desktopSrc,
  mobileSrc,
  alt,
  desktopPosition = 'center',
  mobilePosition = 'center',
  desktopScale = 1,
  mobileScale = 1,
  label,
  index,
  className = '',
}: EditorialMediaProps) {
  const style = {
    '--desktop-position': desktopPosition,
    '--mobile-position': mobilePosition,
    '--desktop-scale': desktopScale,
    '--mobile-scale': mobileScale,
  } as CSSProperties

  if (desktopSrc) {
    return (
      <picture className={`editorial-media ${className}`.trim()} style={style}>
        {mobileSrc && <source media="(max-width: 700px)" srcSet={mobileSrc} />}
        <img src={desktopSrc} alt={alt} loading="eager" decoding="async" />
      </picture>
    )
  }

  return (
    <div className={`editorial-media editorial-media--placeholder ${className}`.trim()} style={style} aria-label={label}>
      {index !== undefined && <strong aria-hidden="true">{String(index + 1).padStart(2, '0')}</strong>}
      <i aria-hidden="true" />
    </div>
  )
}
